import { useDispatch } from 'react-redux'
import { LoginInterface } from '../../Interfaces/LoginInterface'
import { RaytebRequests } from '../../_services'
import useFetch from '../../_services/fetch'
import { TextBoxTypeEnum } from '../../enums/TextBoxTypeEnum'
import { Avatar, LoadingFit, SecondaryLayout } from '../../share/Components'
import { Button, RaytebForm, TextBox } from '../../share/Elements'
import { loginUser } from '../../storeManager/Reducers/userSlice'
import { useNavigate } from 'react-router'
import HelTag from 'react-helmet'

const Login = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { reFetch, isLoading } = useFetch<LoginInterface, LoginInputModel>({
    request: RaytebRequests.Dashboard_Login_POST(),
    onSuccess(data) {
      dispatch(loginUser(data))
      navigate('/')
    },
  })
  return (
    <>
      <HelTag>
        <title>صفحه ورود</title>
      </HelTag>
      <LoadingFit isLoading={isLoading} />
      <div className='px-9 relative h-full w-full'>
        <div className='flex justify-center items-center py-4'>
          <Avatar
            url={'/images/watermark.svg'}
            className='!rounded-none w-24 h-24'
          />
        </div>
        <RaytebForm
          checkIsRequired={true}
          className='flex justify-start items-center flex-col gap-7 mt-6'
          onSubmit={(e) => {
            reFetch({
              personCode: e.target['PersonCode'].value,
              password: e.target['Password'].value,
            })
          }}
        >
          <TextBox
            className=''
            Type={TextBoxTypeEnum.Text}
            innerText='کد ملی'
            isRequired={true}
            name='PersonCode'
            autoComplete='on'
          ></TextBox>
          <TextBox
            autoComplete='on'
            className=''
            Type={TextBoxTypeEnum.Password}
            innerText='رمز عبور'
            isRequired={true}
            name='Password'
          ></TextBox>
          <Button
            type='submit'
            className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs w-32 h-9 !shadow-lg'
          >
            تایید
          </Button>
        </RaytebForm>
      </div>
    </>
  )
}

Login.Layout = ({ children }) => {
  return <SecondaryLayout title={'ورود'}>{children}</SecondaryLayout>
}
export default Login
